import { Box } from "@mui/material";
import axios from "axios";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import MyResourceTile from "./MyResourceTile";

import { useLocalStorage } from "../../../hooks";
import * as dashboardActions from "../../../redux/reducers/dashboardReducer";
import { dashboardState } from "../../../redux/reducers/dashboardReducer";


import noEventImage from "../../../assets/noEventImage.svg";
import { useToast } from "../../../provider/ToastProvider";
import { clearLoadingData, loadingState, setSectionLoading } from "../../../redux/reducers/loadingReducer";
import { getUrlForUsers } from "../../../utils/confighelpers";
import WarningDialog from "../../confirmationModals/WarningDialog";
import { TwButton, TwContainer, TwMainLayout } from "../../../components/tailwind";

export default function MyResourceList({ navigation, profileFor, title }) {
  const { addToast, addSuccessToast, addErrorToast } = useToast();
  const dispatch = useDispatch();
  const loadingReduxState = useSelector(loadingState);
  const navigate = useNavigate();
  const dashboardReduxState = useSelector(dashboardState);
  const [userToken] = useLocalStorage("userToken");
  const [userDetail, setUserDetail] = React.useState({});
  const [allowAddResource, setAllowAddResource] = React.useState(false);
  const [resourceList, setResourceList] = React.useState([]);
  const [openWarningDialog, setOpenWarningDialog] = React.useState(false);

  React.useEffect(() => {
    dispatch(clearLoadingData());
    (async () => {
      await getUserInfo();
    })(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (userDetail?.myPlatformFeeProfile?.myResource && userDetail?.myPlatformFeeProfile?.myResource?.numberOfAllowResource !== undefined) {
      setAllowAddResource(resourceList.length < userDetail?.myPlatformFeeProfile?.myResource?.numberOfAllowResource ? true : false)
    } else {
      setAllowAddResource(resourceList.length < 1 ? true : false)
    }
  }, [userDetail, resourceList]);


  const handleSessionClick = async (id, serviceData) => {
    dispatch(dashboardActions.setResourceId(id));
    navigate("/myresource/update", {
      state: {
        from: "list",
      },
      replace: true
    });
  };


  const getUserInfo = async () => {
    const manageClassesConfig = {
      method: "get",
      url: `${getUrlForUsers()}getUserInfo`,
      headers: {
        "x-access-token": userToken,
      },
    };
    dispatch(setSectionLoading(true));
    const responce = await axios(manageClassesConfig);
    dispatch(setSectionLoading(false));
    if (responce.status === 200) {
      setUserDetail(responce.data.data);
      if (responce.data.data && Array.isArray(responce.data.data.myResource)) {
        setResourceList(responce.data.data.myResource);
      } else {
        setResourceList([]);
      }
    }
  };

  const renderResources = (data) => {
    return (
      <ul className="divide-y divide-gray-100">
        {data.length > 0 ? (
          data.map((item, idx) => {
            const modifiedData = {
              popover: true,
              item: item,
              allResources: data,
            };
            return (
              <MyResourceTile
                {...modifiedData}
                key={idx}
                handleSessionClick={() => {
                  handleSessionClick(item._id, item);
                }}
                reload={() => {
                  getUserInfo();
                }}
              />
            );
          })
        ) : (
          <li className={"text-black text-center"}>no teams are available</li>
        )}
      </ul>
    );
  };

  return (
    <TwMainLayout
      headTitle={title}
      headActions={[
        (<TwButton
          variant="orange"
          className="sm:min-w-32"
          onClick={() => {
            if (allowAddResource) {
              dispatch(dashboardActions.setResourceId(-1));
              navigate("/myresource/add", {
                state: {
                  from: "list",
                },
                replace: true
              });
            } else {
              setOpenWarningDialog(true)
            }
          }}
        >
          Add New
        </TwButton>),
      ]}
      children={
        <TwContainer className="">
          {resourceList.length ? (<div
            className={"sm:max-w-sm md:max-w-sm w-full"}
          >
            {renderResources(resourceList)}
          </div>) : (loadingReduxState.sectionLoading !== undefined && loadingReduxState.sectionLoading === false) ? (
            <div className="flex flex-col justify-center items-center gap-5 text-center h-full">
              <img
                className={"w-40 md:w-60"}
                src={noEventImage}
                alt={""}
              />
              <div className={"text-brown-coffee text-lg font-bold"}>
                No Teams Configured
              </div>
              <div className="flex justify-center items-center w-full">
                <TwButton
                  variant="orange"
                  onClick={() => {
                    dispatch(dashboardActions.setResourceId(-1));
                    navigate("/myresource/add", {
                      state: {
                        from: "list",
                      },
                      replace: true
                    });
                  }}
                >
                  Add a new Team
                </TwButton>
              </div>
            </div>
          ) : ""}
          <WarningDialog
            open={openWarningDialog}
            text={`You are only allowed ${userDetail?.myPlatformFeeProfile?.myResource?.numberOfAllowResource || 1} resources as per your subscription. If you need to add more resources you will have to upgrade your subscription.`}
            isCloseBtn={false}
            btnCloseText={"Close"}
            btnSubmitText={"Update Subscription"}
            onClose={() => setOpenWarningDialog(false)}
            onSubmit={async () => {
              setOpenWarningDialog(false)
              navigate("/businessprofilesetup/subscription/upgrade", {
                state: {
                  origin: "upgradeSubscription",
                },
                replace: true
              });
            }}
          />
        </TwContainer>} />
  );
}
